import { render, staticRenderFns } from "./BaseAnimatedCounter.vue?vue&type=template&id=61f8639d&scoped=true"
import script from "./BaseAnimatedCounter.vue?vue&type=script&lang=js"
export * from "./BaseAnimatedCounter.vue?vue&type=script&lang=js"
import style0 from "./BaseAnimatedCounter.vue?vue&type=style&index=0&id=61f8639d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f8639d",
  null
  
)

export default component.exports